import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {UserSessionService} from '../../../../services/user-session.service'
import {environment} from '../../../../../environments/environment'
import {PERMISSION} from "@generated-backend-types";
import {LocalStorageService} from "ngx-webstorage";
import {CoreModule} from "../../../core.module";
import {RouterModule} from "@angular/router";
import {IfHasAnyPermissionDirective} from "../../directives/if-has-any-permission.directive";
import {IfHasAllAndAnyPermissionsDirective} from "../../directives/if-has-all-and-any-permissions.directive";
import {IfHasAllPermissionsDirective} from "../../directives/if-has-all-permissions.directive";

enum CONTENT {
  ACCOUNTING,
  GUEST_MANAGEMENT,
  EVENT_MANAGEMENT,
  PLANNING,
  RESOURCES,
  SETTINGS,
  ADMINISTRATIONS,
  VEHICLE_CONSULTATION

}

interface Item {
  collapsed: boolean
  content: CONTENT
}

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CoreModule,
      RouterModule,
      IfHasAnyPermissionDirective,
      IfHasAllAndAnyPermissionsDirective,
      IfHasAllPermissionsDirective
    ],
    standalone: true
})
export class SidebarComponent implements OnInit {

  public readonly content = CONTENT;

  public items = [
    {content: CONTENT.GUEST_MANAGEMENT, collapsed: true},
    {content: CONTENT.EVENT_MANAGEMENT, collapsed: true},
    {content: CONTENT.ACCOUNTING, collapsed: true},
    {content: CONTENT.PLANNING, collapsed: true},
    {content: CONTENT.VEHICLE_CONSULTATION, collapsed: true},
    {content: CONTENT.RESOURCES, collapsed: true},
    {content: CONTENT.SETTINGS, collapsed: true},
    {content: CONTENT.ADMINISTRATIONS, collapsed: true},
  ];


  ngOnInit() {
    this.updateState(this.storageService.retrieve('sidebarState'))

  }

  private updateState(collapsedState: string) {
    if (collapsedState) {
      const parsed = JSON.parse(collapsedState);
      this.items = this.items
        .map((item: Item, index) => {
          return {content: item.content, collapsed: parsed[index].collapsed ?? false}
        });
    }
  }

  public collapsed(content: CONTENT): boolean {
    const index = this.items.findIndex(v => v.content === content);
    return this.items[index].collapsed ?? false
  }


  public toggle(content: CONTENT) {

    const index = this.items.findIndex(v => v.content === content)

    if (!this.items[index]) {
      return;
    }
    this.items[index].collapsed = !this.items[index].collapsed;

    // Save collapsed state to localStorage
    this.storageService.store('sidebarState', JSON.stringify(this.items));
  }


  public permission = PERMISSION
  public environment = environment


  public logout() {
    this.auth.logout().subscribe()
  }

  public constructor(private readonly auth: UserSessionService,
                     private readonly storageService: LocalStorageService,
                     private readonly cdr: ChangeDetectorRef) {

    this.storageService.observe('sidebarState').subscribe(
      (t) => {
        this.updateState(t);
        this.cdr.detectChanges()
      }
    )

  }
}
